export var LOCAL_STORAGE_ITEMS = {
    PILES: "piles",
    TOKEN: "token",
};
export default LOCAL_STORAGE_ITEMS;
